import ISlideFrame from '@/components/interfaces/SlideFrame';
import { plato_api_slide_path } from '@/modules/routes';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

interface SlideFrameResponse {
  mascotEnabled: boolean;
  slideFrame: ISlideFrame | null;
  slideFrameId: number | null;
}

export default function useUpdateSlideFrame(slideId: number | string) {
  return useMutation({
    mutationFn: (slideFrameId: number | null) => (
      axios
        .patch<SlideFrameResponse>(
        plato_api_slide_path(slideId),
        { slide_frame_id: slideFrameId },
      )
        .then(res => res.data)
    ),
  });
}
